/**
 * Two-level treatment choice for the «После лечения» image (expert feedback round 3, D-028):
 * a treatment group, then for lens replacement the IOL type, and for IOL / ICL the toric version.
 */

import { baseCorrection, isToric, type CorrectionId } from './profile';

export type TreatmentGroup = 'none' | 'glasses' | 'progressive' | 'rgp' | 'lasik' | 'icl' | 'iol';
export type IolType = 'iol_mono' | 'iol_monoplus' | 'iol_edof' | 'iol_tri';

export const TREATMENT_GROUPS: TreatmentGroup[] = ['none', 'glasses', 'progressive', 'rgp', 'lasik', 'icl', 'iol'];
export const IOL_TYPES: IolType[] = ['iol_mono', 'iol_monoplus', 'iol_edof', 'iol_tri'];

export function groupOf(id: CorrectionId): TreatmentGroup {
  const base = baseCorrection(id);
  return base.startsWith('iol_') ? 'iol' : (base as TreatmentGroup);
}

export function iolTypeOf(id: CorrectionId): IolType | null {
  const base = baseCorrection(id);
  return base.startsWith('iol_') ? (base as IolType) : null;
}

export function hasToricVersion(group: TreatmentGroup): boolean {
  return group === 'iol' || group === 'icl';
}

export function composeCorrection(group: TreatmentGroup, iol: IolType, toric: boolean): CorrectionId {
  if (group === 'iol') return (toric ? `${iol}_toric` : iol) as CorrectionId;
  if (group === 'icl') return toric ? 'icl_toric' : 'icl';
  return group;
}

/** A correction that stands for the group in availability checks. */
export function groupProbe(group: TreatmentGroup): CorrectionId {
  return group === 'iol' ? 'iol_tri' : group;
}

export { isToric };
